(function () {

    angular
        .module('smartertoolsApp')
        .service('authenticationService', ['$http', '$q', '$log', '$rootScope', 'refreshToken', authenticationService]);

    function authenticationService($http, $q, $log, $rootScope, refreshToken) {
        const vm = this;
        var validatePromise = null;
        var nextValidate = new Date();

        // Functions
        vm.setAuthFlags = setAuthFlags;
        vm.getAuthFlags = getAuthFlags;
        vm.setAuthToken = setAuthToken;
        vm.getAuthToken = getAuthToken;
        vm.createAccount = createAccount;
        vm.isLoggedIn = isLoggedIn;
        vm.isReseller = isReseller;
        vm.setLoggedInEmail = setLoggedInEmail;
        vm.getLoggedInEmail = getLoggedInEmail;
        vm.login = login;
        vm.logout = logout;
        vm.setRefreshToken = setRefreshToken;
        vm.getRefreshToken = getRefreshToken;
        vm.resetPassword = resetPassword;
        vm.clearSession = clearSession;
        vm.showTermsCondition = showTermsCondition;
        vm.sendAccepted = sendAccepted;
        vm.getAgreement = getAgreement;

        // -----------------------------------------------

        function fireLoggedIn() {
            refreshToken.clearCached();
            $rootScope.$broadcast('authentication:logged-in', {});
            $rootScope.$applyAsync();
        }

        function fireLoggedOut() {
            refreshToken.clearCached();
            $rootScope.$broadcast('authentication:logged-out', {});
            $rootScope.$applyAsync();
        }

        function isLoggedIn() {
            logoutIfRefreshTokenInvalid();
            return !!getRefreshToken();
        }

        function isReseller() {
            const flags = getAuthFlags();
            return flags && flags.indexOf('reseller') >= 0;
        }

        // Gets

        function getAuthToken() {
            return sessionStorage.getItem('stAuthToken');
        }

        function getAuthFlags() {
            return localStorage.getItem('stAuthFlags');
        }

        function getLoggedInEmail() {
            return localStorage.getItem('stEmail');
        }

        function getRefreshToken() {
            return localStorage.getItem('stRefreshToken') || sessionStorage.getItem('stRefreshToken');
        }

        function getAgreement(callback) {
            const termId = 1;
            $http.post(apiRootUrl + `v1/account/partner/getPartnerAgreement`, JSON.stringify({ TermCondID: termId }))
                .then((response) => { callback(response.data); });
        }

        // Sets

        function setAuthToken(newToken) {
            sessionStorage.setItem('stAuthToken', newToken);
            return newToken;
        }

        function setAuthFlags(newToken) {
            localStorage.setItem('stAuthFlags', newToken);
            return newToken;
        }

        function setLoggedInEmail(newEmail) {
            localStorage.setItem('stEmail', newEmail);
            return newEmail;
        }

        function setRefreshToken(newToken, longTerm) {
            if (longTerm === void 0) {
                longTerm = false;
            }
            if (longTerm) {
                sessionStorage.setItem('stRefreshToken', ''); // wipe out session level one
                localStorage.setItem('stRefreshToken', newToken);
            } else {
                localStorage.setItem('stRefreshToken', ''); // wipe out long term one
                sessionStorage.setItem('stRefreshToken', newToken);
            }
            return newToken;
        }

        function login(email, password, rememberMe, callback) {
            const params = {
                EmailAddress: email,
                Password: password
            };
            $http.post(apiRootUrl + `v1/auth/authenticate-user`, JSON.stringify(params))
                .then((result) => {
                    var data = result.data;
                    setAuthToken(data.AccessToken);
                    setAuthFlags(data.Flags);
                    setRefreshToken(data.RefreshToken, rememberMe);
                    setLoggedInEmail(data.EmailAddress);
                    fireLoggedIn();
                    if (callback) {
                        callback();
                    }
                }, (result) => {
                    clearSession();
                    if (callback) {
                        const data = result && result.data;
                        callback(data);
                    }
                });
        }


        function showTermsCondition(callback) {
            $http.get(apiRootUrl + `v1/account/partner/checkAgreement`)
                .then(
                    (response) => { callback(response.data.ShouldShow); },
                    (error) => { callback(false); }
            );
        }

        function sendAccepted(callback) {
            $http.post(apiRootUrl + `v1/account/partner/setAccepted`)
                .then((response) => { callback(response.data); });
        }

        function logout(callback) {
            const refresh = getRefreshToken();
            if (!refresh) {
                clearSession();
                if (callback) {
                    callback();
                }
                fireLoggedOut();
                return;
            }

            const params = JSON.stringify({ RefreshToken: refresh });
            $http.post(apiRootUrl + 'v1/auth/revoke-refresh-token', params)
                .then(() => {
                    clearSession();
                    if (callback) {
                        callback();
                    }
                    fireLoggedOut();
                }, () => {
                    clearSession();
                    if (callback) {
                        callback();
                    }
                    fireLoggedOut();
                });
        }

        function resetPassword(email, callback) {
            const params = JSON.stringify({ EmailAddress: email });
            $http.post(apiRootUrl + 'v1/auth/password-reset-email', params)
                .then(() => {
                    if (callback) {
                        callback();
                    }
                });
        }

        function createAccount(inputs, rememberMe, callback) {
            $http.post(apiRootUrl + 'v1/auth/create-account', JSON.stringify(inputs))
                .then((result) => {
                    var data = result.data;
                    if (data.Success) {
                        setAuthToken(data.AccessToken);
                        setAuthFlags(data.Flags);
                        setRefreshToken(data.RefreshToken, rememberMe);
                        setLoggedInEmail(data.EmailAddress);
                        fireLoggedIn();
                        if (callback) {
                            callback();
                        }
                    } else {
                        clearSession();
                        if (callback) {
                            callback(data);
                        }
                    }
                }, (result) => {
                    clearSession();
                    if (callback) {
                        var data = result && result.data;
                        callback(data);
                    }
                });
        }

        function clearSession() {
            setAuthToken('');
            setAuthFlags([]);
            setRefreshToken('');
            setLoggedInEmail('');
            sessionStorage.setItem('smartertoolsCartItemCount', 0);
            sessionStorage.setItem('smartertoolsCartGuid', '');
            if (sessionStorage)
                sessionStorage.clear();
            if (localStorage)
                localStorage.clear();
        }

        function logoutIfRefreshTokenInvalid() {
            var defer = $q.defer();

            if (validatePromise) {
                return validatePromise;
            }

            if (!getRefreshToken() || nextValidate > new Date()) {
                defer.resolve('OK');
                return defer.promise;
            }

            const params = { RefreshToken: getRefreshToken() };

            validatePromise = defer.promise;

            $http.post(apiRootUrl + 'v1/auth/validate-refresh-token', JSON.stringify(params))
                .then((resp) => {
                    if (resp && resp.data && resp.data.Success && resp.data.IsValid)
                        return;
                    logout(onLogoutComplete);
                }, () => { logout(onLogoutComplete); });

            return defer.promise;

            function onLogoutComplete() {
                window.RefreshLoginTopArea();
                location.href = '/';
                defer.resolve('OK');
                validatePromise = null;
                nextValidate = new Date((new Date()).getTime() + 30000);
            }
        }
    }

})();